export { ShareWithManagerButton } from './ShareWithManagerButton';
export type { ShareWithManagerButtonProps, TShareWithManagerButtonState } from './types';